import { isEmpty } from "lodash-es"
import { ComponentProps } from "react"
import { FieldErrorsImpl } from "react-hook-form"
import { FormErrorSummary } from "~/app/components/FormErrorSummary"

type OriginalErrorSummaryProps = ComponentProps<typeof FormErrorSummary>
type UniversalErrorSummaryProps = Pick<
  OriginalErrorSummaryProps,
  "className" | "title" | "description" | "isVisible" | "scrollIntoView"
> & {
  errors?: OriginalErrorSummaryProps["errors"]
}

export const UniversalErrorSummary = (props: UniversalErrorSummaryProps) => {
  const { errors, ...rest } = props
  const { graphql, ...formErrorsWithoutGraphql } = errors as Partial<
    FieldErrorsImpl<{ [x: string]: unknown }>
  >
  const graphqlErrors = graphql?.types?.graphql
  const serverErrors = Array.isArray(graphqlErrors)
    ? graphqlErrors
    : typeof graphqlErrors === "string"
      ? [graphqlErrors]
      : []

  if (formErrorsWithoutGraphql && !isEmpty(formErrorsWithoutGraphql)) {
    return <FormErrorSummary errors={formErrorsWithoutGraphql} {...rest} />
  }

  if (!isEmpty(serverErrors)) {
    return (
      <FormErrorSummary
        isVisible
        {...rest}
        description={
          <ul className="list-inside list-disc">
            {serverErrors.map((error, i) => (
              <li key={i}>{error}</li>
            ))}
          </ul>
        }
      />
    )
  }
  return null
}
